import "./text.css.ts.vanilla.css-mistica.js";
var e = "splu5g7", a = "splu5g8", p = "splu5g9", t = {
    mobileSize: "var(--splu5g0)",
    desktopSize: "var(--splu5g1)",
    mobileLineHeight: "var(--splu5g2)",
    desktopLineHeight: "var(--splu5g3)",
    lineClamp: "var(--splu5g4)"
}, l = "splu5g5", i = "splu5g6";
export { e as text, a as truncate, p as truncateToOneLine, t as vars, l as withWordBreak, i as withoutWordBreak };
